import styled from "styled-components";

import FlexBox from "../FlexBox";
import { Body2, Caption, H2 } from "../Headings";
import { BRICK_TERRACOTA, DAVYS_GREY } from "../colors";

import IntroIcon from "../../../assets/AiChat/ai-intro-icon.svg";
import AiIcon from "../../../assets/ai-icon-filled.svg";
import { FiChevronRight } from "react-icons/fi";

const Intro = styled(FlexBox)`
  flex-direction: column;
  flex-grow: 1;
  padding: 1rem;
  justify-content: space-between;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;
`;

const IntroText = styled(FlexBox)`
  flex-direction: column;
  gap: 0.5rem;
  background: linear-gradient(
    90deg,
    #624584 0%,
    ${BRICK_TERRACOTA[800]} 76.91%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
`;

const PromptBox = styled(FlexBox)`
  padding: 0.5rem;
  border: 1px solid ${DAVYS_GREY[400]};
  border-radius: 0.5rem;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;

  &:hover {
    background-color: ${DAVYS_GREY[200]};
  }
`;

const PromptIcon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

const ChevronIcon = styled(FiChevronRight)`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
`;

const AiChatIntroSection = ({
  userName,
  greeting,
  onPromptSelect,
  suggestedPrompts,
}) => {
  return (
    <Intro>
      <IntroText>
        <img src={IntroIcon} alt="AI Chat Icon" width={40} height={40} />

        <FlexBox column margin="0 0 1rem 0">
          <H2>Hi {userName}</H2>
          <H2 bold>{greeting}</H2>
        </FlexBox>
      </IntroText>

      {suggestedPrompts?.length > 0 && (
        <FlexBox column gap="0.5rem">
          <Caption
            spacing="8%"
            textTransform="uppercase"
            bold
            color={DAVYS_GREY[700]}
            margin="0 0 0.5rem 0"
          >
            Suggestive prompts you can ask:
          </Caption>

          <FlexBox column rowGap="0.5rem">
            {suggestedPrompts.map(prompt => (
              <PromptBox key={prompt} onClick={() => onPromptSelect?.(prompt)}>
                <FlexBox columnGap="0.25rem" align="flex-start">
                  <PromptIcon src={AiIcon} alt="" />
                  <Body2>{prompt}</Body2>
                </FlexBox>
                <ChevronIcon />
              </PromptBox>
            ))}
          </FlexBox>
        </FlexBox>
      )}
    </Intro>
  );
};

export default AiChatIntroSection;
